import {
  TButtonTranslations,
} from './npm-controller-menu.ts';

const buttonTranslations: TButtonTranslations = {
  LOAD_JOB: {
    label: 'Načítať zákazku',
    confirmMessage: '',
    confirmHeader: '',
    confirmLabel: '',
  },
  START_JOB: {
    label: 'Spustiť zákazku',
    confirmMessage: 'Zákazka sa okamžite spustí.',
    confirmHeader: 'Spustiť {recipeCode} na {assetDisplayName}?',
    confirmLabel: 'Spustiť {recipeCode}',
  },
  ABORT_JOB: {
    label: 'Prerušiť zákazku',
    confirmMessage: 'Bežiaca zákazka sa okamžite zastaví.',
    confirmHeader: 'Prerušiť zákazku {jobNo} ({recipeCode}) na {assetDisplayName}?',
    confirmLabel: 'Prerušiť {jobNo}',
  },
  RESUME_JOB: {
    label: 'Obnoviť zákazku',
    confirmMessage: 'Zákazka pokračuje tam, kde sa zastavila.',
    confirmHeader: 'Obnoviť {recipeCode} na {assetDisplayName}?',
    confirmLabel: 'Obnoviť {recipeCode}',
  },
};

export default {
  button: buttonTranslations,
};
